module.exports = __webpack_public_path__ + "static/icon_seamless-1fba88f50fc71ea7df2faa4fce1cd914.png";